/*
 * Module for the mini Learner, which shows a smaller form of the learner results
 * for easy dragging and dropping into topics
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListModule",
  "modules/topicsSplit/miniLearner/highlightedTranscript/highlightedTranscriptModule",
  "modules/topicsSplit/miniLearner/miniLearnerView",
  "modules/learner/learnerTranscriptModal/learnerTranscriptModalModule",
  "modules/topicsSplit/miniLearner/miniLearnerModel",
], function (
  Marionette,
  Messenger,
  SortableListModule,
  HighlightedTranscriptModule,
  MiniLearnerView,
  LearnerTranscriptModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "miniLearner";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (expandBoolean) {
      const transcriptCollection = Messenger.reqres.request("learner:results");
      this.matchType = Messenger.reqres.request("learner:results:match:type"); //get match type of these transcripts
      //make sure we have learner results to show
      if (transcriptCollection) {
        //determine if we want headers for clusters or not by checking if the first model is a cluster (if the
        // collection is empty...who cares)
        const isClustered = transcriptCollection.length > 0 && transcriptCollection.at(0).isCluster;
        let headers;
        if (isClustered) {
          headers = Messenger.reqres.request("mini:learner:clustered:headers");
        } else {
          headers = Messenger.reqres.request("mini:learner:headers");
        }
        this.layout = new MiniLearnerView.miniLearnerLayout();
        this.results = this.addSubModule(
          new SortableListModule({
            region: this.layout.miniLearnerResults,
            headers: headers,
            recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
            hideHeader: true,
            namespace: this.name,
            doNotResetCollection: true, //keep filtering from the main learner list
          }),
        );
        this.highlightedTranscript = this.addSubModule(
          new HighlightedTranscriptModule({ region: this.layout.highlightedTranscript }),
        );

        //event to expand the leaner (basically, go to the learner page).  Make sure to save first!
        this.layout.on(
          "expand:learner",
          function () {
            Messenger.save(function (success) {
              if (success) {
                Messenger.vent.trigger("show:learner");
              }
            }, this);
          },
          this,
        );

        this.layout.on(
          "show",
          function () {
            this._showSubViews(transcriptCollection);
          },
          this,
        );
        this.showRegion(this.layout);
        if (expandBoolean) {
          this.layout.expand(); //make sure the mini-learner is expanded when the boolean is true
        }
      }
    },
    _showSubViews: function (transcriptCollection) {
      this.results.show(transcriptCollection);
    },
    _setUpVents: function () {
      //if the miniLearner is open, set the highlighted transcript
      Messenger.vent.on(
        "set:highlighted:transcript",
        function (transcript) {
          if (this.isOpen) {
            this.highlightedTranscript.show(transcript);
            this.layout.showHighlightedTranscript();
            //if the transcript is removed, hide the highlighted transcript area
            this.layout.listenToOnce(transcript, "remove", function () {
              this.hideHighlightedTranscript();
            });
          }
        },
        this,
      );

      Messenger.vent.on(
        "miniLearner:selected:row",
        function (transcript) {
          //determine the title used based on whether this is a question or a cluster
          let modalTitle;
          if (transcript.isCluster) {
            modalTitle = "learner.transcript.clusteredTitle";
          } else {
            modalTitle = "learner.transcript.title";
          }
          Messenger.vent.trigger(
            "show:modal",
            LearnerTranscriptModalModule,
            {
              matchType: this.matchType,
              disableLearnerFeatures: false,
            },
            transcript,
            {
              title: modalTitle,
              closeButton: true,
              closeOnBackgroundClick: true,
              trackInteraction: {
                action: "Show Learner Transcript",
                object: "Learner Transcript",
                source: "Mini Learner",
              },
            },
          );
        },
        this,
      );
    },
  });
});
